import { Slot as RadixSlot } from 'radix-ui'

export const Slot: typeof RadixSlot.Root = RadixSlot.Root
export const Slottable: typeof RadixSlot.Slottable = RadixSlot.Slottable
